/**
 * Named constants for the five split-screen handshakes that fire across
 * the demo arc. Backed by `ui.SplitScreenHandshake` events whose
 * `payload.number` matches one of these values.
 *
 *   1 — VERIFY_CTA          T1 0.6 Submit-a-Proposal gate
 *   2 — PROPOSAL_ACCEPTED   T1 1.8 OrbID materialisation + first proposal
 *   3 — CONTRACT_CAPTURED   T1 2.1 / T2 4.5 contract capture
 *   4 — SINGLE_WINDOW       T1 2.7 single-window clearance
 *   5 — LC_ISSUED           T1 3.4 escrow / T2 4.13 / T3 5.x LC issued
 */
export const HANDSHAKE = {
  VERIFY_CTA: 1,
  PROPOSAL_ACCEPTED: 2,
  CONTRACT_CAPTURED: 3,
  SINGLE_WINDOW: 4,
  LC_ISSUED: 5,
} as const;

export type HandshakeNumber = (typeof HANDSHAKE)[keyof typeof HANDSHAKE];
